import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { InputBase } from '@mui/material';
import { enqueueSnackbar } from 'actions';
import ModalDialog from '../../../../../../../../components/ModalDialog/ModalDialog.js';
import { SetFormState, RemoveAttachment, ToggleDeleteAttachmentDialog } from '../../../../../../actions/SiteTrackerActions.js';

const TeamsDeleteFileDialog = (props) => {
	const { author, open, onClose, onApply, className, tableId, rowId, ...rest } = props;
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.siteTrackerReducer.formState);
	const userId = useSelector(state => state.session.user.id);
	const role = useSelector(state => state.session.user.role);

	const _onConfirmClick = () => {
		dispatch(RemoveAttachment(userId, tableId, rowId));
		dispatch(ToggleDeleteAttachmentDialog(false));
		dispatch(enqueueSnackbar({ message: 'Attachment deleted', options: { variant: 'info' } }));
		// setFormState({
		// 	...formState,
		// 	values: {
		// 		...formState.values,
		// 		// hasAttachmentFiles: false
		// 	}
		// });
	};

	return (
		<ModalDialog
			maxWidth="xs"
			onClose={onClose}
			open={open}
			title="Delete attachment"
			confirmLabel="Ok"
			onConfirmClicked={_onConfirmClick}
		>
			<InputBase
				// className={classes.margin}
				defaultValue="Do you want to delete this attachment file?"
				inputProps={{ 'aria-label': 'naked' }}
				fullWidth
			/>
		</ModalDialog>
	);
};

TeamsDeleteFileDialog.propTypes = {
	author: PropTypes.object,
	className: PropTypes.string,
	onApply: PropTypes.func,
	onClose: PropTypes.func,
	open: PropTypes.bool,
	tableId: PropTypes.any,
	rowId: PropTypes.any
};

export default TeamsDeleteFileDialog;
